import React, { useState, useEffect } from "react";
import "react-calendar/dist/Calendar.css";
import Calendar from "react-calendar";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import axios from "axios";

const HomeEvents = () => {
  const [value, onChange] = useState(new Date());
  const [toppers, setToppers] = useState([]);
  const [events, setEvents] = useState([]);

  const baseUrl = process.env.REACT_APP_BASE_URL;
  const school = process.env.REACT_APP_SCHOOL;

  const slides = [
    { title: "/images/is3.jpg", description: "Name-1" },
    { title: "/images/is5.jpg", description: "Name-2" },
  ];

  // const fallbackEvents = [
  //   { eventdate: "2020-12-23", title: "EDUCATIONAL FACILITIES & STUDENT SAFETY" },
  //   { eventdate: "2021-01-24", title: "SPECIONAL FACILITIES & STUDENT SAFETY" },
  //   { eventdate: "2021-01-24", title: "SPECbaseUIAL STRATEGIES FOR GIRLS & MOTIVATIONAL PLANS" },
  //   { eventdate: "2020-12-21", title: "Result has been declared" },
  //   { eventdate: "2020-12-23", title: "EDUCATrlIAL STRATEGIES FOR GIRLS & MOTIVATIONAL PLANS" },
  //   { eventdate: "2020-12-21", title: "Result has been declared" },
  // ];

  useEffect(() => {
    if (!baseUrl || !school) return;

    axios
      .get(`${baseUrl}/${school}/items/toppers?fields=*,photo.*`)
      .then((res) => {
        if (res?.data?.data) setToppers(res.data.data);
      })
      .catch(console.log);

    axios
      .get(`${baseUrl}/${school}/items/news_events?fields=*.*.*`)
      .then((res) => {
        if (res?.data?.data) setEvents(res.data.data);
      })
      .catch(console.log);

  }, [baseUrl, school]);
  
  return (
    <div className="container-fluid bg-teal py-4 py-md-5">
      <div className="container">
        <div className="row gap-4 pr-4">

          {/* News */}
          <div className="col-12 col-sm-6 col-lg-4 ">
            <div className="card shadow-sm h-100">
              <div className="card-body d-flex flex-column " style={{ height: "300px" }}>
                <h5 className="card-title text-center fw-bold mb-3 bg-info text-white py-2">
                  News & Events
                </h5>

                <div className="flex-grow-1 overflow-auto" style={{ maxHeight: "300px" }}>
                  {events && events.length > 0 ? (
                    events.map((item, i) => (
                      <div key={i} className="d-flex mb-2 border rounded">
                        <div
                          className="bg-info text-white p-2 small text-center"
                          style={{ minWidth: "100px" }}
                        >
                          {item.dates}
                        </div>

                        <div className="bg-light p-2 small flex-grow-1">
                          {item.events}
                        </div>
                      </div>
                    ))
                  ) : (
                    <p className="text-center">No News Found</p>
                  )}
                </div>

              </div>
            </div>
          </div>

          {/* Calendar */}
          <div className="col-12 col-sm-6 col-lg-4">
            <div className="card shadow-sm h-100 text-center">
              <div className="card-body">
                <h5 className="card-title fw-bold mb-3 bg-info text-white py-2">
                  School Calendar
                </h5>

                <div className="d-flex justify-content-center">
                  <Calendar onChange={onChange} value={value} />
                </div>
              </div>
            </div>
          </div>

          {/* Toppers */}
          <div className="col-12 col-sm-12 col-lg-4">
            <div className="card shadow-sm h-100">
              <div className="card-body">
                <h5 className="card-title text-center fw-bold mb-3 bg-info text-white py-2">
                  Topper (2025-2026)
                </h5>

                <Carousel showThumbs={false} autoPlay infiniteLoop >
                  {(toppers.length > 0 ? toppers : slides).map(
                    (item, index) => (
                      <div key={index}>
                        <img
                          src={
                            item?.photo?.data?.full_url
                              ? item.photo.data.full_url.replace("http://", "https://")
                              : item.title
                          }
                          alt="topper"
                          className="img-fluid w-100"
                          style={{ height: "280px", objectFit: "cover" }}
                        />
                        <h6 className="bg-info text-white text-center p-2">
                          {item.name || item.description}
                        </h6>
                      </div>
                    )
                  )}
                </Carousel>

              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default HomeEvents;